/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 Saxophone.glb --transform 
Files: Saxophone.glb [50.52KB] > C:\Users\alexr\Documents\Development\Lofi site\public\Instruments\Saxophone-transformed.glb [5.93KB] (88%)
*/

import React, { useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { Sparkles } from "@react-three/drei";

export function Saxophone(props) {
  const { nodes, materials } = useGLTF(
    "/Instruments/Saxophone-transformed.glb"
  );
  const [sound, setSound] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const clickHandler = () => {
    console.log("clicked sax");
    if (isPlaying == false) {
      const sound = new Howl({
        src: "/sounds/saxophone.mp3",
        autoplay: false,
        volume: 0.3,
        onplay: () => {
          setIsPlaying(true);
          //requestAnimationFrame(step);
          // console.log(isPlaying);
          // console.log("on play");
          // requestAnimationFrame(step);
        },
        onend: () => {
          setIsPlaying(false);
        },
      });
      sound.play();

      setSound(sound);
    }
  };

  return (
    <group
      {...props}
      dispose={null}
      onClick={clickHandler}
      onPointerEnter={() => {
        document.body.style.cursor = "pointer";
      }}
      onPointerLeave={() => {
        document.body.style.cursor = "default";
      }}
    >
      {isPlaying && (
        <Sparkles
          count={100}
          scale={1}
          size={100}
          speed={2}
          color={"#00FF00"}
          position={[4.673, 2.5, -3.652]}
        />
      )}
      <group
        position={[4.673, 1.575, -3.652]}
        rotation={[0, 1.562, 0]}
        scale={0.1}
      >
        <mesh
          geometry={nodes.Saxophone_Circle003_1.geometry}
          material={materials["FFEB3B.001"]}
        />
        <mesh
          geometry={nodes.Saxophone_Circle003_1_1.geometry}
          material={materials["1A1A1A.002"]}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/Instruments/Saxophone-transformed.glb");
